var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47254 0 0 4.47293 0 10C0 15.5275 4.47293 20 10 20C15.5275 20 20 15.5271 20 10C20 4.47254 15.527 0 10 0ZM10 18.4375C5.33621 18.4375 1.5625 14.6635 1.5625 10C1.5625 5.33621 5.33652 1.5625 10 1.5625C14.6638 1.5625 18.4375 5.33652 18.4375 10C18.4375 14.6638 14.6634 18.4375 10 18.4375Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.37207C9.56852 8.37207 9.21875 8.72184 9.21875 9.15332V14.1843C9.21875 14.6158 9.56852 14.9655 10 14.9655C10.4315 14.9655 10.7812 14.6157 10.7812 14.1843V9.15332C10.7812 8.72184 10.4315 8.37207 10 8.37207Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.41553C10.5825 7.41553 11.0547 6.94333 11.0547 6.36084C11.0547 5.77835 10.5825 5.30615 10 5.30615C9.41751 5.30615 8.94531 5.77835 8.94531 6.36084C8.94531 6.94333 9.41751 7.41553 10 7.41553Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.5087eb9c83f5b6dd56079d946abb2947.svg";
export { ForwardRef as ReactComponent };